/** The description every answer starts with: accepting a request needs no more. */
export const DEFAULT_ANSWER_TEXT = 'تایید است'

/** The text suggested for an answer whose description was left at the default. */
const SUGGESTED_ANSWER_TEXT = {
  reject: 'مورد قبول نیست',
  review: 'نیاز به بازنگری دارد',
}

/** The description the editor holds for a text, as the editor stores it. */
export function answerHtml(text) {
  return `<p>${text}</p>`
}

/** The default description, as the editor holds it. */
export const DEFAULT_ANSWER_HTML = answerHtml(DEFAULT_ANSWER_TEXT)

/** The text without its markup, e.g. nothing for an emptied editor. */
function plainText(html) {
  const {body} = new DOMParser().parseFromString(html, 'text/html')
  return body.textContent.trim()
}

/**
 * Asks the user about a rejection or a review that still has the default
 * description. Resolves to the description to answer with, or to null when the
 * user wants to edit the description by hand.
 */
export async function answerTextFor($swal, html, action) {
  if (plainText(html) !== DEFAULT_ANSWER_TEXT || !SUGGESTED_ANSWER_TEXT[action]) {
    return html
  }

  const suggested = SUGGESTED_ANSWER_TEXT[action]
  const result = await $swal({
    title: 'متن توضیحات با وضعیت انتخابی مطابقت ندارد',
    text: `متن توضیحات «${DEFAULT_ANSWER_TEXT}» است، اما برای این وضعیت «${suggested}» پیشنهاد می‌شود.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: `استفاده از «${suggested}»`,
    cancelButtonText: 'ویرایش دستی',
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-outline-secondary ml-1',
    },
    buttonsStyling: false,
  })

  return result.value ? answerHtml(suggested) : null
}
